import { render, staticRenderFns } from "./NewCandidate.vue?vue&type=template&id=67ab7468"
import script from "./NewCandidate.vue?vue&type=script&lang=js"
export * from "./NewCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports